import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import Header from './Common/Header'
import Footer from './Common/Footer'
import Helmet from './Common/Helmet'
import { getCustomerCareDetails } from "../Actions/TourAction"

const mapStateToProps = (state) => {
    return {
        reducer: state.Tour
    }
}

const mapDispatchToProps = dispatch => ({
    getCustomerCareDetails: () => dispatch(getCustomerCareDetails())
});


function getActive(hash) {
    var active = 0
    switch (hash) {
        case "#section1":
            active = 1
            break;
        case "#section2":
            active = 2
            break;
        case "#section3":
            active = 3
            break;
        case "#section4":
            active = 4
            break;
        case "#section5":
            active = 5
            break;

        default:
            break;
    }
    return active
}


class CustomerCare extends Component {

    constructor(props) {
        super(props);
        const hash = window.location.hash;

        this.state = {
            list: getActive(hash)
        }

        this.props.getCustomerCareDetails()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        this.scrollToHash();
    }
    componentDidUpdate(prevProps) {
        if (
            prevProps.reducer.custCare !== this.props.reducer.custCare &&
            this.props.reducer.custCare
        ) {
            this.scrollToHash();
        }
    }

    scrollToHash = () => {
        const hash = window.location.hash;

        if (hash) {
            setTimeout(() => {
                const element = document.querySelector(hash);

                if (element) {
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });
                }
            }, 100);
        }
    };

    render() {
        var customer_care = this.props.reducer.custCare
        return <Fragment>
            <Header Home={false} />
            <div className="maindiv">
                <section className="contentwrap">
                    <div className="container2">

                        <div className="container">

                            <h2>Customer Care</h2>
                            <div className="row">
                                <nav className="col-sm-3 caretab" id="myScrollspy">
                                    <ul className="nav nav-pills nav-stacked" data-spy="affix" data-offset-top="500">
                                        <li onClick={() => this.setState({ list: 1 })} className={this.state.list == 1 ? "active" : null}><a href="#section1">Help Center </a></li>
                                        <li onClick={() => this.setState({ list: 2 })} className={this.state.list == 2 ? "active" : null}><a href="#section2">Privacy Policy </a></li>
                                        <li onClick={() => this.setState({ list: 3 })} className={this.state.list == 3 ? "active" : null}><a href="#section3">Cookie Policy</a></li>
                                        <li onClick={() => this.setState({ list: 4 })} className={this.state.list == 4 ? "active" : null}><a href="#section4">Product Disclaimers</a></li>
                                        <li onClick={() => this.setState({ list: 5 })} className={this.state.list == 5 ? "active" : null}><a href="#section5">Terms & Conditions</a></li>
                                    </ul>
                                </nav>

                                {customer_care != null ?
                                    <div className="col-md-9 col-sm-12 t-content">
                                        <div id="section1" style={{scrollMarginTop:120}}>
                                            <h3>Help Center</h3>

                                            <p>
                                                <div dangerouslySetInnerHTML={{ __html: customer_care.help_center }} />
                                            </p>

                                            <h3>Security</h3><br />

                                            <p>
                                                <div dangerouslySetInnerHTML={{ __html: customer_care.security }} />
                                            </p>
                                        </div>
                                        <div id="section2" style={{scrollMarginTop:150}}>
                                            <h3>Privacy Policy </h3>
                                            <p>
                                                <div dangerouslySetInnerHTML={{ __html: customer_care.privacy_policy }} />
                                            </p>

                                        </div>
                                        
                                        <div id="section3" style={{scrollMarginTop:150}}>
                                            <h3>Cookie Policy</h3>
                                            <p>
                                                <div dangerouslySetInnerHTML={{ __html: customer_care.cookie_policy }} />
                                            </p>
                                        </div>

                                        <div id="section4" style={{scrollMarginTop:150}}>
                                            <h3>Product Disclaimers</h3>
                                            <p>
                                                <div dangerouslySetInnerHTML={{ __html: customer_care.product_disclaimers }} />
                                            </p>

                                        </div>

                                        <div id="section5" style={{scrollMarginTop:150}}>
                                            <h3>Terms & Conditions</h3>
                                            <p>
                                                <div dangerouslySetInnerHTML={{ __html: customer_care.terms_conditions }} />
                                            </p>
                                        </div>
                                    </div> : null}
                            </div>
                        </div>

                    </div>

                </section>

            </div>


            <Footer hyperLink={false}/>

        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(CustomerCare);